import { MetaViewportPropertiesMap } from './types';

const createMetaViewportMap = (content): MetaViewportPropertiesMap => {
  const map: Map<string, string> =
    content !== ''
      ? new Map(content.split(',').map((rule) => rule.trim().split('=')))
      : new Map();
  return {
    set(key, value) {
      map.set(key, value);
      return this;
    },
    delete(key) {
      map.delete(key);
      return this;
    },
    build() {
      if (map.size === 0) return '';
      return Array.from(map.entries())
        .map(([key, value]) => {
          return `${key}=${value}`;
        })
        .join(',');
    },
  };
};

const lock = (): void => {
  const rules = 'width=device-width,height=device-height,initial-scale=1.0';
  let metaViewport = document.head.querySelector("meta[name='viewport']");
  if (!metaViewport) {
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'viewport');
    document.head.appendChild(meta);
    metaViewport = meta;
    metaViewport.setAttribute('content', rules);
  }

  metaViewport.setAttribute(
    'content',
    createMetaViewportMap(metaViewport.getAttribute('content'))
      .set('user-scalable', '0')
      .build()
  );
};

const unlock = (): void => {
  const metaViewport = document.head.querySelector("meta[name='viewport']");
  if (!metaViewport) return;
  metaViewport.setAttribute(
    'content',
    createMetaViewportMap(metaViewport.getAttribute('content'))
      .delete('user-scalable')
      .build()
  );
};

export default { lock, unlock };
